import React, {useState} from 'react';

import {QueryingConnectionSearchInput} from 'instruments/connections/ConnectionSearchInput';
import {InstrumentData} from 'instruments/instrument-data/InstrumentDataConstants';
import InstrumentDataTable from 'instruments/instrument-data/InstrumentDataTable';
import {FilterKey} from 'search/SearchConstants';
import Stepper, {StepperStep} from 'ui-library/stepper/Stepper';

import {ConnectionListingGraphQL} from '../../../../graphql-fragments/instruments/__generated/ConnectionListingGraphQL';
import {
  ColumnMappingStepperStepProps,
  getColumnMappingStepperStep,
} from '../column-mapping/ColumnMappingStepperStep';
import DataFrameNameField, {DataFrameNameFieldProps} from '../steps/DataFrameNameField';

interface InstrumentDataSelectorProps {
  connectionId: string;
  value: InstrumentData | null;
  onChange: (val: InstrumentData) => void;
}

function InstrumentDataSelector(props: InstrumentDataSelectorProps): JSX.Element {
  const [instrumentData, setInstrumentData] = useState<Array<InstrumentData>>([]);
  const {value} = props;
  const selectedRowIndices = new Set(value ? [instrumentData.findIndex(({id}) => id === value.id)] : []);

  return (
    <InstrumentDataTable
      instrumentData={instrumentData}
      allowMultiple={false}
      setInstrumentData={setInstrumentData}
      selectedRowIndices={selectedRowIndices}
      onSelectRow={(rowIndex) => {
        props.onChange(instrumentData[rowIndex]);
      }}
      columns={['File name', 'Status', 'Data type', 'Modified at']}
      filterOptions={[]}
      initialFilterValues={{[FilterKey.CONNECTION]: [props.connectionId]}}
    />
  );
}

export interface ConnectionDataStepperFormProps {
  dataFrameNameFieldProps: DataFrameNameFieldProps;
  connectionId: string | null;
  onChangeConnection: (connection: ConnectionListingGraphQL) => void;
  instrumentData: InstrumentData | null;
  onChangeInstrumentData: (instrumentData: InstrumentData | null) => void;
  columnMappingProps?: ColumnMappingStepperStepProps;
}

export default function ConnectionDataStepperForm(props: ConnectionDataStepperFormProps): JSX.Element {
  return (
    <Stepper>
      <StepperStep title="Select connection">
        <QueryingConnectionSearchInput
          autoFocus={false}
          onChange={(connections) => {
            if (connections.length) {
              props.onChangeConnection(connections[0]);
            }
          }}
          connectionIds={props.connectionId != null ? [props.connectionId] : []}
          shouldAllowMultiple={false}
        />
      </StepperStep>
      <StepperStep title="Choose file">
        {props.connectionId != null && (
          <InstrumentDataSelector
            connectionId={props.connectionId}
            value={props.instrumentData}
            onChange={props.onChangeInstrumentData}
          />
        )}
      </StepperStep>
      {props.columnMappingProps != null && getColumnMappingStepperStep(props.columnMappingProps)}
      <StepperStep title="Name table">
        <DataFrameNameField {...props.dataFrameNameFieldProps} />
      </StepperStep>
    </Stepper>
  );
}
